import React from 'react'

export const useSnackbar = () => ({ open: () => {}, close: () => {} })
export const SnackbarContext = React.createContext({})
